export default __webpack_public_path__ + "static/media/img-soon-block.1c86d315.svg";